import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'

class StickyCartButton extends BaseComponent {
  button: Nullable<HTMLElement>

  constructor() {
    super()

    this.button = this.querySelector('[data-cart-sticky-button]')
  }

  connectedCallback(): void {
    window.addEventListener('scroll', this.handleWindowScroll)
  }

  disconnectedCallback(): void {
    window.removeEventListener('scroll', this.handleWindowScroll)
  }

  handleWindowScroll = (): void => {
    const header = document.querySelector(
      '.shopify-section.shopify-section-header',
    )

    if (header && this.button) {
      const headerRect = header.getBoundingClientRect()
      const isVisible = headerRect.bottom + this.button.offsetHeight < 0

      this.button.toggleAttribute('visible', isVisible)
    }
  }
}

export default StickyCartButton
